export default {
  abroadBaseInfo: '/developer/api/V3/dim_info',
  abroadStats: '/developer/api/V3/stats',
  abroadStatsExport: '/developer/api/V3/stats/export',
  abroadCurve: '/developer/api/V3/curve',
  abroadSummaryCards: '/developer/api/V3/summary_cards',
  abroadReportConfig: '/developer/api/V3/report_config'
};
